// import { getOnHotkeyToggleMarkDefault } from '../../common/utils/getOnHotkeyToggleMarkDefault';
import { SlatePlugin } from '../../slatePlugins.types';
// import { DEFAULTS_Q } from './defaults';
// import { deserializeQ } from './deserializeCite';
import { renderLeafQ } from './renderLeafQ';
import { QPluginOptions } from './types';

/**
 * Enables support for bold formatting
 */
export const QPlugin = (options?: QPluginOptions): SlatePlugin => ({
  renderLeaf: renderLeafQ(options),
  // deserialize: deserializeQ(options),
  // onKeyDown: getOnHotkeyToggleMarkDefault({
  //   key: 'q',
  //   defaultOptions: DEFAULTS_Q,
  //   options,
  // }),
});
